// extracted by mini-css-extract-plugin
export var aboveInput = "_lh-0";
export var actionButton = "_lh-5";
export var actionButtonContainer = "_lh-1";
export var actionIcon = "_lh-6";
export var aiInfoContainer = "_lh-2";
export var attachmentWrapper = "_lh-7";
export var bold = "_lh-3";
export var checkIcon = "_lh-8";
export var clickingRecipientBar = "_lh-11";
export var commentThreadSwitch = "_lh-a";
export var draftImage = "_lh-b";
export var draftImageContainer = "_lh-c";
export var draftImages = "_lh-e";
export var editButton = "_lh-g";
export var editor = "_lh-f";
export var editorContainer = "_lh-y";
export var editorErrorTooltipWrapper = "_lh-9";
export var headerDivider = "_lh-h";
export var icon = "_lh-i";
export var info = "_lh-j";
export var internal = "_lh-n";
export var internalDivider = "_lh-k";
export var internalMessage = "_lh-l";
export var messageInputCard = "_lh-m";
export var messageInputForm = "_lh-o";
export var messageInputFormInternal = "_lh-p";
export var options = "_lh-q";
export var publicMessageCustomer = "_lh-s";
export var publicMessageMerchant = "_lh-r";
export var removeImageButton = "_lh-d";
export var replyButtons = "_lh-t";
export var showSignatureButton = "_lh-u";
export var spinner = "_lh-v";
export var verticalButtonDivider = "_lh-4";
export var visibilitySelector = "_lh-w";
export var warning = "_lh-x";
export var wrappingText = "_lh-z";
export var writingInternalNoteTopBorder = "_lh-10";